import React from "react";
import AiChatSection from "./components/ai-assitance/AiChatSection";

function AiChatPage() {
  return (
    <div>
      <AiChatSection />
    </div>
  );
}

export default AiChatPage;
